import React, { useState } from "react";
import Box from "@mui/material/Box";

import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import SecurityPhraseApi from "../api/security_phrase";
import Alert from "./Alert";
import { setSecurityEnabled } from "../store/security_phrase";
import BotUsersAPI from "../api/bots";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    background: "#24262b",
    border: "2px solid #000",
    boxShadow: 24,
    p: 3,
};

export default function CashoutModal({
    botId,
    setCashoutTrigger,
    cashoutTrigger,

}) {
    const [open, setOpen] = useState(false);

    const phraseActive = useSelector((state) => state.phrase.security);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [cashout, setCashout] = useState();
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
    const [empty, setEmpty] = useState(false);
    const [dataToShow, setDataToShow] = useState({});

    const handleCashout = () => {
        if (!cashout) {
            setEmpty(true);
            setTimeout(() => {
                setEmpty(false);
            }, 3000);
        } else {
            BotUsersAPI.setBotCashout(botId, {
                bot: {
                    cashout: cashout,
                },
            })
                .then((res) => {
                    BotUsersAPI.viewBot({ id: botId })
                        .then((response) => {
                            setDataToShow(response.data['bot']);

                        })
                        .catch((error) => console.log(error));
                    cashoutTrigger ? setCashoutTrigger(false) : setCashoutTrigger(true);
                    setSuccess(true);
                    setTimeout(() => {
                        setSuccess(false);
                        handleClose();
                    }, 3000);


                })
                .catch((err) => {
                    setFailed(true);
                    setTimeout(() => {
                        setFailed(false);
                    }, 3000);
                });
        }
    };

    return (
        <div>
            <button
                style={{
                }}
                className="primary-btn view"
                onClick={handleOpen}
            >
                Set Cashout
            </button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className="security-phrase-main">
                        <div className="security-phrase-inner">
                            <div className="security-phrase-content">
                                <div
                                    style={{
                                        width: "80%",
                                    }}
                                    className="alert-container absolute"
                                >
                                    {success && (
                                        <Alert
                                            type="success"
                                            message="Cashout updated successfully."
                                        />
                                    )}
                                    {failed && (
                                        <Alert type="error" message="Unable to set cashout." />
                                    )}
                                    {empty && (
                                        <Alert type="error" message="Field must be filled" />
                                    )}
                                </div>

                                <p className="white">Add Cashout to Bot</p>

                                <div className="security-phrase width">
                                    <input
                                        className="security-phrase-inputs form-control"
                                        type="number"
                                        placeholder="Enter Cashout "
                                        value={cashout}
                                        onChange={(e) => {
                                            setCashout(e.target.value);
                                        }}
                                    />
                                </div>

                                <div className="security-phrase width justified">
                                    <button
                                        // name={phraseActive === true ? "update" : "create"}
                                        style={{
                                            padding: "10px 25px",
                                        }}
                                        className="buttons-primary"
                                        onClick={handleCashout}
                                    >
                                        Set Cashout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
